// @ts-check

export const SET_OBJECTS = 'SET_OBJECTS';
export const ADD_OBJECTS = 'ADD_OBJECTS';
export const SET_PATH = 'SET_PATH';
export const SET_SYNC = 'SET_SYNC';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_SELECTION = 'SET_SELECTION';
export const ADD_SELECTION = 'ADD_SELECTION';
export const REMOVE_SELECTION = 'REMOVE_SELECTION';
export const SET_DROPDOWN_METADATA = 'SET_DROPDOWN_METADATA';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_EDITING = 'SET_EDITING';
export const SET_NAME = 'SET_NAME';
export const SET_MOVE_DIALOG_OPEN = 'SET_MOVE_DIALOG_OPEN';
export const SET_REMOVE_DIALOG_OPEN = 'SET_REMOVE_DIALOG_OPEN';
export const REMOVE_OBJECTS = 'REMOVE_OBJECTS';
export const UPDATE_CHILDREN = 'UPDATE_CHILDREN';

/**
 * Set objects, clearing existing objects.
 *
 * @param {Record<string, any>} [objects] - Map of objects by id
 */
export const setObjects = (objects) => ({
    type: SET_OBJECTS,
    objects,
});

/**
 * Add new objects as children of `id`.
 *
 * @param {string} id - Object id to add children to.
 * @param {Record<string, any>} objects - Objects to add.
 * @param {string[]} children - Children to assign to object.
 */
export const addObjects = (id, objects, children) => ({
    type: ADD_OBJECTS,
    id,
    objects,
    children,
});

/**
 * Remove Objects id
 *
 * @param {string} parentID - Parent folder id
 */
export const removeObjects = (parentID) => ({
    type: REMOVE_OBJECTS,
    parentID,
});

/**
 * Update children list when moving an Object
 *
 * Automatically remove from the selection
 * @param {string} parentID
 * @param {string} destID
 * @param {string} destType
 * @param {Record<string, any>} [topFolders]
 */
export const updateChildren = (parentID, destID, destType, topFolders) => ({
    type: UPDATE_CHILDREN,
    parentID,
    destID,
    destType,
    topFolders,
});

/**
 * Load a new path to replace existing path
 *
 * @param {string[]} path
 */
export const setPath = (path) => ({
    type: SET_PATH,
    path,
});

/**
 * Set current selection to list of ids
 *
 * @param {string[]} ids
 */
export const setSelection = (ids) => ({
    type: SET_SELECTION,
    ids,
});

/**
 * Add ids/types to current selection
 *
 * @param {string[]} ids
 */
export const addSelection = (ids) => ({
    type: ADD_SELECTION,
    ids,
});

/**
 * Remove ids from current selection
 *
 * @param {string[]} ids
 */
export const removeSelection = (ids) => ({
    type: REMOVE_SELECTION,
    ids,
});

/**
 * Set sync state `sync` for current selection
 *
 * @param {boolean} sync
 */
export const setSync = (sync) => ({
    type: SET_SYNC,
    sync,
});

/**
 * Set state for MoveDialog box
 *
 * @param {{open: boolean}} state
 */
export const setMoveDialogOpen = (state) => ({
    type: SET_MOVE_DIALOG_OPEN,
    state,
});

/**
 * Set state for RemoveDialog box
 *
 * @param {{open: boolean}} state
 */
export const setRemoveDialogOpen = (state) => ({
    type: SET_REMOVE_DIALOG_OPEN,
    state,
});

/**
 * Set object permissions to public or private `permissions` state.
 *
 * @param {boolean} permissions - public/private state
 */
export const setPermissions = (permissions) => ({
    type: SET_PERMISSIONS,
    permissions,
});

/**
 * Set the dropdown tooltip state.
 *
 * @typedef DropdownMetadata
 * @prop {number} [count]
 * @prop {boolean} [sync]
 * @prop {boolean} [public]
 * @prop {boolean} [open]
 * @prop {Element} [element]
 *
 * @param {DropdownMetadata} metadata
 */
export const setDropdownMetadata = (metadata) => ({
    type: SET_DROPDOWN_METADATA,
    metadata,
});

/**
 * Set search string
 *
 * @param {string} string string to filter files with
 */
export const setSearch = (string) => ({
    type: SET_SEARCH,
    string,
});

/**
 * @param {boolean} editing
 */
export const setEditing = (editing) => ({
    type: SET_EDITING,
    editing,
});

/**
 * @param {string} id
 * @param {string} name
 */
export const setName = (id, name) => ({
    type: SET_NAME,
    id,
    name,
});
